import { render } from "./HomePage.vue?vue&type=template&id=2715d8a8&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "@/styles/home-page.css?vue&type=style&index=0&lang=css&external"
import "./HomePage.vue?vue&type=style&index=1&id=2715d8a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2715d8a8"]])

export default __exports__